/**
 * @file 对不规范的接口response data层级和error做处理，返回业务端数据 or false or报错提示
 * @author liujiaojiao01
 */

import Vue from 'vue';
import toast from 'veui/plugins/toast';
Vue.use(toast);
/**
* 根据接口返回结果 =》返回业务端数据 or false or 报错提示
* status: 0, msg: "", proxy: "plugin", data: {data: {list: [1], total: 10}, error_code: 0} =》{list: [1], total: 10}
* code: 320203, msg: "网络代理请求ral请求错误, Talk To Server Failed"  => msg报错提示 &&false
* code: 0, data: 3, msg: ''  => 3
* code: 0, data: [], msg: ''  => []
* code: 31106, msg: '未找到商户'  => msg报错提示 && false
* code: 0, data: {statusCode: 200,data: {error_code: 100}} => 当前请求error_code不为0, 请检查接口 && false
* code: 0, data: {statusCode: 100}  => 当前请求statusCode不为200 && false
* code: 0, data: {statusCode: 200,data: {list: []}}, msg: '' => {list: []}
* code: 0, data: {statusCode: 200,data: {error_code: 0,error_msg: '',data: {list : [],page_index: 1}}}, msg: '' => {list: [], page_index:1}
* code: 0, data: {statusCode: 200,data: {code: 0,msg: '',data: {list : [],page_index: 1}}}, msg: '' => {list: [], page_index:1}
* code: 0, data: {statusCode: 200,data: {options: [{a:1}]}} => {options: [{a:1}]}
*
*/

let responseError = false;

const errMap = {
    // code、error_code为后端返回
    code: {
        statusMsg: 'msg',
        statusCode: 0
    },
    error_code: {
        statusMsg: 'error_msg',
        statusCode: 0
    },
    statusCode: {
        statusMsg: '',
        statusCode: 200
    },
    // 兼容插件status
    status: {
        statusMsg: 'msg',
        statusCode: 0
    }
};

function handleResponseErrCode(result, identifier) {
    if (result[identifier] !== undefined
        && +result[identifier] !== errMap[identifier].statusCode) {
        const defaultErrMsg = '当前请求' + identifier + '不为' + errMap[identifier].statusCode + ', 请检查接口';
        const errMsg = result[errMap[identifier].statusMsg] || defaultErrMsg;
        console.log('res code err>>>', errMsg);
        this && this.$Message && this.$Message.error(errMsg);
        responseError = true;
    }
}

// 处理响应数据
export function normalizeResponseData(res, isMaterialGet) {
    let index = 0;
    let dataLevel = 2;
    let result = res;
    responseError = false;
    while (index <= dataLevel
        && (result.code !== undefined
            || result.errno !== undefined
            || result.statusCode !== undefined
            || result.error_code !== undefined
            || result.status !== undefined)) {
        // 兼容‘material_get’接口res.data.data中出现status字段
        if (index === 2 && isMaterialGet && isMaterialGet === 'isMaterialGet') {
            return result;
        }
        handleResponseErrCode.call(this, result, 'code');
        handleResponseErrCode.call(this, result, 'error_code');
        handleResponseErrCode.call(this, result, 'statusCode');
        handleResponseErrCode.call(this, result, 'status');
        if (responseError) {
            return false;
        }
        if (!result.data) {
            console.log('res data err>>>', result.data);
            return false;
        }
        index++;
        result = result.data;
    }
    return result;
}

// 中台后端框架层报错需要在catch里处理
export function normalizeResponseError(err, tost) {
    if (typeof err === 'object' && err !== null) {
        if (err.code !== undefined && +err.code !== 0 && err.msg
            || err.status && err.msg) {
            if (tost) {
                this.$toast.error(err.msg);
            }
            else {
                this.$Message && this.$Message.error(err.msg);
            }
        }
        else if (err.error_code !== undefined && +err.error_code !== 0 && err.error_msg) {
            if (tost) {
                this.$toast.error(err.error_msg);
            }
            else {
                this.$Message && this.$Message.error(err.error_msg);
            }
        }
    }
    if (Object.prototype.toString.call(err) === '[object String]') {
        if (tost) {
            this.$toast.error(err);
        }
        else {
            this.$Message && this.$Message.error(err);
        }
    }
    console.log('normalize response error>>>>>', err);
}

Vue.prototype.$normalizeResponseData = normalizeResponseData;
Vue.prototype.$normalizeResponseError = normalizeResponseError;
